export const ErrorMessage = ({ text }) => {
  return (
    <div className="errorMessage">
      <div className="errorText">{text}</div>
    </div>
  );
};
